import { BigNumberish, formatUnits } from "ethers";
import BigNumber from "bignumber.js";

export const formatValue = (value: BigNumberish | undefined, decimal = 30, floatPoint = 2) => {
  return new BigNumber(formatUnits(value ?? 0, decimal)).toFormat(floatPoint);
};

export const compare = (a: bigint, b: bigint) => (a > b ? 1 : a < b ? -1 : 0);
